import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import './LegalPages.css';

const CookiePolicy = () => {
  return (
    <>
      <Navbar />
      <div className="legal-page">
        <div className="legal-container">
          <div className="legal-header">
            <h1>Cookie Policy</h1>
            <p className="legal-updated">Last Updated: April 9, 2026</p>
          </div>

          <div className="legal-content">
            <section className="legal-section">
              <h2>1. Purpose of This Cookie Policy</h2>
              <p>
                This Cookie Policy explains how iGamesTech (operated by iTwelveTech) uses cookies and similar
                technologies when you visit our website, applications, and digital services. It should be read along
                with our Privacy Policy and Terms and Conditions.
              </p>
            </section>

            <section className="legal-section">
              <h2>2. What Cookies Are</h2>
              <p>
                Cookies are small text files stored on your browser or device when you visit a website. They help us
                recognize your device, maintain secure sessions, remember preferences, and understand how our services
                are used.
              </p>
            </section>

            <section className="legal-section">
              <h2>3. Types of Cookies We Use</h2>
              <div className="definition-list">
                <div className="definition-item">
                  <strong>Strictly Necessary Cookies</strong>
                  <p>
                    Required for core platform functions such as page navigation, security, form submission, and
                    account/session management. These cookies cannot be switched off in our systems.
                  </p>
                </div>
                <div className="definition-item">
                  <strong>Performance and Analytics Cookies</strong>
                  <p>
                    Help us measure traffic, identify errors, and improve user experience by understanding how users
                    interact with our pages and features.
                  </p>
                </div>
                <div className="definition-item">
                  <strong>Functional Cookies</strong>
                  <p>
                    Remember your selected settings such as language, region, or interface preferences to provide a
                    more personalized experience.
                  </p>
                </div>
                <div className="definition-item">
                  <strong>Advertising and Campaign Cookies</strong>
                  <p>
                    May be used to measure the effectiveness of marketing campaigns and provide more relevant
                    promotional content where applicable and legally permitted.
                  </p>
                </div>
              </div>
            </section>

            <section className="legal-section">
              <h2>4. Similar Technologies</h2>
              <p>
                In addition to cookies, we may use local storage, SDK identifiers, pixels, and server logs for
                analytics, fraud prevention, and service optimization.
              </p>
            </section>

            <section className="legal-section">
              <h2>5. Third-Party Cookies</h2>
              <p>
                Some cookies may be set by trusted third-party providers such as analytics, infrastructure, customer
                support, or payment services. These providers process data according to their own policies and our
                contractual safeguards.
              </p>
            </section>

            <section className="legal-section">
              <h2>6. Cookie Duration</h2>
              <p>
                Cookies may be either:
              </p>
              <ul>
                <li><strong>Session cookies:</strong> deleted when you close your browser.</li>
                <li><strong>Persistent cookies:</strong> remain for a defined period or until manually deleted.</li>
              </ul>
              <p>
                Retention periods vary by cookie purpose and are limited to what is necessary for that purpose.
              </p>
            </section>

            <section className="legal-section">
              <h2>7. Your Cookie Choices</h2>
              <p>
                You can manage cookies through your browser settings, including blocking or deleting cookies. Please
                note that disabling certain cookies may affect login flows, saved settings, and overall functionality.
              </p>
              <p>
                Where required by law, we will request consent before setting non-essential cookies.
              </p>
            </section>

            <section className="legal-section">
              <h2>8. Updates to This Policy</h2>
              <p>
                We may update this Cookie Policy to reflect service changes, legal requirements, or operational needs.
                The updated version will be posted on this page with a revised "Last Updated" date.
              </p>
            </section>

            <section className="legal-section">
              <h2>9. Contact Information</h2>
              <p>
                For cookie-related questions or requests, contact us at:
              </p>
              <div className="contact-info">
                <p><strong>Email:</strong> info@igamestech.com</p>
                <p><strong>Phone:</strong> +91 92113 43912</p>
                <p><strong>Address:</strong> Unit No. 1017, 10th Floor, SS Omnia, Sector 88, Gurugram</p>
              </div>
            </section>

            <section className="legal-section legal-footer-section">
              <p className="legal-company-info">
                <strong>Company Details:</strong><br />
                iGamesTech is a brand operated by iTwelveTech.<br />
                Unit No. 1017, 10th Floor, SS Omnia, Sector 88, Gurugram<br />
                Email: info@igamestech.com | Phone: +91 92113 43912
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CookiePolicy;
